import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";

import Loader from "../../../components/Loader/Loader";
import { toastError, toastSuccess } from "../../../common/Toast";
import config from "../../../config/config";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import Select from "react-select";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";

const SubCompany = () => {
  const paramObject = useParams();
  const token = localStorage.getItem("Token");
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [timeZoneData, setTimeZoneData] = useState([]);

  const [formValues, setFormValues] = useState({
    Name: "",
    Timezone: "",
  });

  console.log(formValues, "formValues check")

  useEffect(() => {
    setLoading(true);

    axios
      .get(`${config.priceRulesBaseUrl}/pricerules/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const dropdownOptions = res.data.ResponseData.map((u) => ({
          label: u.Name,
          value: u.Id,
        }));
        setTimeZoneData(dropdownOptions);

        if (paramObject?.id) {
          axios
            .get(`${config.locationBaseUrl}/locations/getsubcompany`, {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            })
            .then((res2) => {
              setLoading(false);
              const allSubCompanies = res2.data.ResponseData || [];
              const found = allSubCompanies.find(
                (item) => item.ID == paramObject.id
              );

              if (found) {
                setFormValues({
                  Name: found.Name || "",
                  Timezone: found.LocationID,
                });

                // If custom timezone, add it to dropdown options
                // if (!dropdownOptions.some((opt) => opt.value === selectedLocation.value)) {
                //   setTimeZoneData((prev) => [...prev, selectedLocation]);
                // }
              }
            })
            .catch(() => setLoading(false));
        } else {
          setLoading(false);
        }
      })
      .catch(() => setLoading(false));
  }, [paramObject.id, token]);

  const handleInputChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formValues.Name.trim()) {
      toastError("Name is required.");
      return;
    }
    if (!formValues.Timezone) {
      toastError("Location is required.");
      return;
    }

    setLoading(true);

    const payload = {
      ID: paramObject.id || 0,
      name: formValues.Name,
      LocationID: formValues.Timezone,
    };

    axios
      .post(`${config.locationBaseUrl}/locations/subcomapanyupsert`, payload, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLoading(false);
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess("Sub-company saved successfully.");
          navigate("/sub-company-list");
        } else {
          toastError("Something went wrong.");
        }
      })
      .catch(() => {
        setLoading(false);
        toastError("Server error.");
      });
  };

  return (
    <>
      <Sidebar />
      <Loader loading={loading} />

      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{ position: "fixed", top: "2px", zIndex: 999 }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb" style={{ marginLeft: "12px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/locations">Locations List</Link>
                </li>
                <li className="breadcrumb-item active">Manage Locations</li>
              </ul>
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <h5 className="card-title">Locations Information</h5>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="card-body">
                {/* Name */}
                <div className="row mb-2">
                  <div className="col-sm-6">
                    <div className="row">
                      <label className="col-form-label col-md-4 form-label">
                        Name<span className="text-danger">*</span>
                      </label>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="Name"
                          className="form-control form-control-sm"
                          value={formValues.Name}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Timezone */}
                <div className="row mb-2">
                  <div className="col-sm-6">
                    <div className="row">
                      <label className="col-form-label col-md-4 form-label">
                        Timezone<span className="text-danger">*</span>
                      </label>
                      <div className="col-md-8">
                        <Select
                          options={timeZoneData}
                          value={timeZoneData?.find(el => el.value == formValues?.Timezone)}
                          onChange={(e) =>
                            setFormValues({ ...formValues, Timezone: e.value })
                          }
                          isClearable={true}
                          placeholder="Select Location"
                          className="w-100"
                          styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Buttons */}
                <div className="mt-3">
                  <button type="submit" className="btn btn-sm btn-primary me-2">
                    Save
                  </button>
                  <Link to="/sub-company-list" className="btn btn-sm btn-secondary">
                    Cancel
                  </Link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubCompany;
